import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padNumber'
})

export class PadNumberPipe implements PipeTransform {
  transform(value: number, length: number = 2, padChar: string = '0'): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value.toString().padStart(length, padChar);
  }
}
